import { render } from "./WinerySelectorPage.vue?vue&type=template&id=36f7942e"
import script from "./WinerySelectorPage.vue?vue&type=script&lang=js"
export * from "./WinerySelectorPage.vue?vue&type=script&lang=js"

import "./WinerySelectorPage.vue?vue&type=style&index=0&id=36f7942e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__